import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LegendComponent} from './legend.component'

@NgModule({
  declarations: [LegendComponent],
  imports: [
    CommonModule, FormsModule, ReactiveFormsModule, 
  ],
  exports: [LegendComponent],
  providers: [],
})
export class LegendModule { }